import { render } from "./LHCourseEnrolments.vue?vue&type=template&id=051ab2f5"
import script from "./LHCourseEnrolments.vue?vue&type=script&lang=js"
export * from "./LHCourseEnrolments.vue?vue&type=script&lang=js"

import "./LHCourseEnrolments.vue?vue&type=style&index=0&id=051ab2f5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__